export interface IDataLinkProduct {
  spuId: number;
  skuId: number;
}

export const getLinkForPoizonApp = (
  info: IDataLinkProduct | undefined,
  isMobile: boolean,
): string | undefined => {
  if (!info) return;
  const { skuId, spuId } = info;
  if (isMobile) {
    return `dewulink://m.dewu.com/note?routerUrl=https%3A%2F%2Fm.poizon.com%2Frouter%2Fproduct%2FProductDetail%3FloadUrl%3Dhttps%253A%252F%252Fm.dewu.com%252Frouter%252Fproduct%252FProductDetail%26skuId%3D${skuId}%26spuId%3D${spuId}%26from%3D%26sourceName%3Dpc%26distributionCode%3D%26sellingPointAb%3D0%26phone_os%3Dios%26browser_name%3Dsafari%26m_brand%3Diphone%26eFrom%3Dhttps%253A%252F%252Fcdn-m.dewu.com%252Frouter%252Fproduct%252FProductDetail%253FsourceName%253Dpc%2526spuId%253D${spuId}%2526skuId%253D${skuId}&distributionCode=&evokeType=topLocation&directFrom=cdn-m.dewu.com`;
  }
  return `https://www.dewu.com/product-detail.html?sourceName=h5&spuId=${spuId}&propertyValueId=&skuId=${skuId}`;
};
